import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';

/** Quiet coastal pasture silhouettes. Tiles repeat independently of map ids or
 * entry cameras; colors and terrain anchors belong to the caller's preset.
 * No buildings, landmark features, lights or animated vegetation are baked in. */
export const OUTSKIRTS_SILHOUETTES: Readonly<Record<'bluffs' | 'pasture' | 'reeds', ParallaxSvgSpec>> = {
  bluffs: {
    tile: {
      viewBoxWidth: 2400, viewBoxHeight: 560,
      path: 'M0 560V350 C106 347 179 325 268 294 L337 274L390 237L449 231 '
        + 'L508 177L562 167L616 126L675 128L728 89L780 82L824 54L869 60 '
        + 'L912 108L949 120L987 163L1038 185L1090 228 '
        + 'C1164 257 1251 300 1340 312 C1436 329 1510 314 1575 286 '
        + 'L1638 248L1700 247L1762 210L1828 202L1890 237L1938 243 '
        + 'L2006 288L2072 302 C2184 327 2290 347 2400 350V560Z',
      // Broken rock faces: cool, dim and diagonal rather than walkable ledges.
      glowPath: 'M615 132L676 134L729 96L779 90L780 95L730 102L677 139L616 137Z '
        + 'M829 65L865 70L908 117L944 131L945 137L905 124L863 76L832 71Z '
        + 'M1698 253L1764 217L1826 211L1888 245L1886 250L1824 218L1766 223L1701 259Z',
      glowColor: 0x798299, glowAlpha: 0.12,
    },
  },
  pasture: {
    tile: {
      viewBoxWidth: 2400, viewBoxHeight: 360,
      path: 'M0 360V224 C112 224 184 188 300 174 C391 163 478 176 558 199 '
        + 'C642 223 720 216 802 182 C889 144 992 120 1080 134 '
        + 'C1171 148 1241 181 1330 185 C1430 190 1508 161 1590 150 '
        + 'C1684 135 1760 158 1830 185 C1916 218 2009 197 2100 201 '
        + 'C2200 205 2300 224 2400 224V360Z',
      // Short field contours suggest distance without fences that look solid.
      glowPath: 'M142 245Q325 194 475 222 L474 226Q326 200 144 249Z '
        + 'M844 221Q1019 164 1169 201 L1167 206Q1019 171 846 226Z '
        + 'M1572 231Q1745 193 1902 239 L1900 243Q1743 200 1573 236Z',
      glowColor: 0x70877e, glowAlpha: 0.11,
    },
  },
  reeds: {
    tile: {
      viewBoxWidth: 2400, viewBoxHeight: 220,
      // Low banks and small reed groups, with long quiet gaps behind actors.
      path: 'M0 220V198 C80 196 140 202 210 198 '
        + 'L218 182L214 171L221 180L225 164L226 191L234 182L231 197 '
        + 'C338 190 425 192 510 199 L519 187L516 177L524 188L529 172L530 198 '
        + 'C625 202 706 195 780 194 L786 181L782 171L790 183L797 160L796 191L807 178L803 195 '
        + 'C920 202 1010 191 1108 195 L1116 178L1114 166L1121 183L1127 173L1125 197 '
        + 'C1218 201 1289 195 1382 198 L1389 184L1385 172L1394 185L1400 165L1400 196 '
        + 'C1500 188 1579 195 1670 199 L1678 180L1675 165L1683 181L1692 171L1688 198 '
        + 'C1772 199 1850 192 1938 195 L1945 180L1941 167L1950 181L1955 159L1957 195L1965 183L1963 196 '
        + 'C2050 202 2150 192 2230 196 L2239 182L2236 171L2244 186L2249 172L2248 198 '
        + 'C2300 201 2350 196 2400 198V220Z',
    },
  },
};
